# Tiếng Việt
app:
  title: "VINPROP - Bất động sản"
  home_title: "Bất động sản Việt Nam | Mua & Đầu tư | VINPROP"
  copyright: "© VINPROP 2024-2025"

common:
  view_all: "Xem tất cả"
  send: "Gửi"
  cancel: "Hủy bỏ"
  ok: "OK"
  back: "Quay lại"
  next: "Tiếp theo"
  loading: "Đang tải..."
  error: "Lỗi"
  success: "Thành công"
  back_to_home: "Quay về trang chủ"
  select: "Chọn"
  selected: "Đã chọn"
  error_with_message: "Lỗi: {message}"
  menu: "Thực đơn"
  close: "Đóng"
header:
  hero_text: "Danh mục cập nhật tất cả dự án mới tại Việt Nam"

menu:
  projects_buy: "Mua bất động sản"
  residential_complexes: "Khu phức hợp dân cư"
  gated_communities: "Khu dân cư biệt lập"
  holiday_homes: "Bất động sản nghỉ dưỡng"
  commercial_real_estate: "Bất động sản thương mại"
  services: "Dịch vụ"
  handbook: "Cẩm nang bất động sản"
  research_analytics: "Nghiên cứu và phân tích"
  news_blog: "Tin tức"
  agents: "Dành cho đại lý"
  articles: "Bài viết"
  articles_sub:
    buy_real_estate_vietnam: "Mua bất động sản tại Việt Nam"
    analytics: "Phân tích thị trường"
    investment: "Đầu tư"
  callback: "Gọi lại"
  view_all: "Xem tất cả"

breadcrumbs:
  home: "Trang chủ"

search:
  project_type: "Loại dự án"
  location: "Vị trí"
  bedroom: "Số phòng ngủ"
  min_price: "Giá tối thiểu USD"
  max_price: "Giá tối đa USD"
  search_button: "Tìm kiếm"
  price: "Giá"
  reset: "Đặt lại"
  room_single: "phòng"
  room_few: "phòng"
  room_many: "phòng"
  project_types:
    residential_complex: "Khu dân cư"
    gated_community: "Khu đô thị khép kín"
    villa: "Biệt thự"
    holiday_homes: "Bất động sản nghỉ dưỡng"
    commercial_real_estate: "Bất động sản thương mại"
  rooms:
    one: "1 phòng ngủ"
    many: "{count} phòng ngủ"
    more: "5+ phòng ngủ"
  from_price: "từ {price}"
  to_price: "đến {price}"

object_type:
  invalid: "Không xác định"
  villa: "Biệt thự"
  condotel: "Condotel"
  shophouse: "Nhà phố"
  apartment: "Căn hộ"
  studio: "Studio"
  penthouse: "Penthouse"
  duplex: "Duplex"

amenities:
  invalid: "Không xác định"
  bar: "Quán bar"
  restaurant: "Nhà hàng"
  spa: "Spa"
  yoga: "Yoga"
  convenience_store: "Cửa hàng tiện lợi"
  shopping_mall: "Trung tâm thương mại"
  school: "Trường học"
  kindergarten: "Trường mẫu giáo"
  college: "Trường đại học"
  swimming_pool: "Hồ bơi"
  kids_playground: "Sân chơi trẻ em"
  gym: "Phòng tập thể dục"
  community_room: "Phòng cộng đồng"
  jogging_path: "Đường chạy bộ"
  bbq: "Khu BBQ"
  green_area: "Khu vực xanh"
  tennis_court: "Sân tennis"
  kids_pool: "Hồ bơi trẻ em"
  parking: "Bãi đỗ xe"
  cafe: "Quán cà phê"

countries:
  af: "Afghanistan"
  al: "Albania"
  dz: "Algeria"
  ad: "Andorra"
  ao: "Angola"
  ag: "Antigua và Barbuda"
  ar: "Argentina"
  am: "Armenia"
  au: "Úc"
  at: "Áo"
  az: "Azerbaijan"
  bs: "Bahamas"
  bh: "Bahrain"
  bd: "Bangladesh"
  bb: "Barbados"
  by: "Belarus"
  be: "Bỉ"
  bz: "Belize"
  bj: "Benin"
  bt: "Bhutan"
  bo: "Bolivia"
  ba: "Bosnia và Herzegovina"
  bw: "Botswana"
  br: "Brazil"
  bn: "Brunei"
  bg: "Bulgaria"
  bf: "Burkina Faso"
  bi: "Burundi"
  kh: "Campuchia"
  cm: "Cameroon"
  ca: "Canada"
  cv: "Cape Verde"
  cf: "Cộng hòa Trung Phi"
  td: "Chad"
  cl: "Chile"
  cn: "Trung Quốc"
  co: "Colombia"
  km: "Comoros"
  cg: "Congo"
  cd: "CHDC Congo"
  cr: "Costa Rica"
  ci: "Bờ Biển Ngà"
  hr: "Croatia"
  cu: "Cuba"
  cy: "Síp"
  cz: "Séc"
  dk: "Đan Mạch"
  dj: "Djibouti"
  dm: "Dominica"
  do: "Cộng hòa Dominica"
  ec: "Ecuador"
  eg: "Ai Cập"
  sv: "El Salvador"
  gq: "Guinea Xích đạo"
  er: "Eritrea"
  ee: "Estonia"
  sz: "Eswatini"
  et: "Ethiopia"
  fj: "Fiji"
  fi: "Phần Lan"
  fr: "Pháp"
  ga: "Gabon"
  gm: "Gambia"
  ge: "Gruzia"
  de: "Đức"
  gh: "Ghana"
  gr: "Hy Lạp"
  gd: "Grenada"
  gt: "Guatemala"
  gn: "Guinea"
  gw: "Guinea-Bissau"
  gy: "Guyana"
  ht: "Haiti"
  hn: "Honduras"
  hk: "Hồng Kông"
  hu: "Hungary"
  is: "Iceland"
  in: "Ấn Độ"
  id: "Indonesia"
  ir: "Iran"
  iq: "Iraq"
  ie: "Ireland"
  il: "Israel"
  it: "Ý"
  jm: "Jamaica"
  jp: "Nhật Bản"
  jo: "Jordan"
  kz: "Kazakhstan"
  ke: "Kenya"
  ki: "Kiribati"
  kp: "Triều Tiên"
  kr: "Hàn Quốc"
  kw: "Kuwait"
  kg: "Kyrgyzstan"
  la: "Lào"
  lv: "Latvia"
  lb: "Lebanon"
  ls: "Lesotho"
  lr: "Liberia"
  ly: "Libya"
  li: "Liechtenstein"
  lt: "Lithuania"
  lu: "Luxembourg"
  mo: "Ma Cao"
  mg: "Madagascar"
  mw: "Malawi"
  my: "Malaysia"
  mv: "Maldives"
  ml: "Mali"
  mt: "Malta"
  mh: "Quần đảo Marshall"
  mr: "Mauritania"
  mu: "Mauritius"
  mx: "Mexico"
  fm: "Micronesia"
  md: "Moldova"
  mc: "Monaco"
  mn: "Mông Cổ"
  me: "Montenegro"
  ma: "Morocco"
  mz: "Mozambique"
  mm: "Myanmar"
  na: "Namibia"
  nr: "Nauru"
  np: "Nepal"
  nl: "Hà Lan"
  nz: "New Zealand"
  ni: "Nicaragua"
  ne: "Niger"
  ng: "Nigeria"
  mk: "Bắc Macedonia"
  no: "Na Uy"
  om: "Oman"
  pk: "Pakistan"
  pw: "Palau"
  ps: "Palestine"
  pa: "Panama"
  pg: "Papua New Guinea"
  py: "Paraguay"
  pe: "Peru"
  ph: "Philippines"
  pl: "Ba Lan"
  pt: "Bồ Đào Nha"
  qa: "Qatar"
  ro: "Romania"
  ru: "Nga"
  rw: "Rwanda"
  kn: "Saint Kitts và Nevis"
  lc: "Saint Lucia"
  vc: "Saint Vincent và Grenadines"
  ws: "Samoa"
  sm: "San Marino"
  st: "Sao Tome và Principe"
  sa: "Ả Rập Saudi"
  sn: "Senegal"
  rs: "Serbia"
  sc: "Seychelles"
  sl: "Sierra Leone"
  sg: "Singapore"
  sk: "Slovakia"
  si: "Slovenia"
  sb: "Quần đảo Solomon"
  so: "Somalia"
  za: "Nam Phi"
  ss: "Nam Sudan"
  es: "Tây Ban Nha"
  lk: "Sri Lanka"
  sd: "Sudan"
  sr: "Suriname"
  se: "Thụy Điển"
  ch: "Thụy Sĩ"
  sy: "Syria"
  tw: "Đài Loan"
  tj: "Tajikistan"
  tz: "Tanzania"
  th: "Thái Lan"
  tl: "Đông Timor"
  tg: "Togo"
  to: "Tonga"
  tt: "Trinidad và Tobago"
  tn: "Tunisia"
  tr: "Thổ Nhĩ Kỳ"
  tm: "Turkmenistan"
  tv: "Tuvalu"
  ug: "Uganda"
  ua: "Ukraine"
  ae: "UAE"
  gb: "Vương quốc Anh"
  us: "Hoa Kỳ"
  uy: "Uruguay"
  uz: "Uzbekistan"
  vu: "Vanuatu"
  va: "Vatican"
  ve: "Venezuela"
  vn: "Việt Nam"
  ye: "Yemen"
  zm: "Zambia"
  zw: "Zimbabwe"

featured_listings:
  title: "Bất động sản nổi bật"
  urban_title: "Ưu đãi bất động sản đô thị tốt nhất cho {month} {year}"
  resort_title: "Ưu đãi bất động sản nghỉ dưỡng tốt nhất cho {month} {year}"
  empty: "Không có bất động sản nổi bật"
  months:
    1: "Tháng Một"
    2: "Tháng Hai"
    3: "Tháng Ba"
    4: "Tháng Tư"
    5: "Tháng Năm"
    6: "Tháng Sáu"
    7: "Tháng Bảy"
    8: "Tháng Tám"
    9: "Tháng Chín"
    10: "Tháng Mười"
    11: "Tháng Mười Một"
    12: "Tháng Mười Hai"

guides:
  title: "Cẩm nang bất động sản"
  coming_soon: "Hướng dẫn này sắp ra mắt. Hãy theo dõi cập nhật!"
  market_guide: "Hướng dẫn thị trường BĐS Việt Nam"
  legal_guide: "Hướng dẫn pháp lý"
  pm_guide: "Hướng dẫn quản lý tài sản"
  buying_guide: "Hướng dẫn mua bất động sản"

articles:
  all_title: "Bài viết"
  related_title: "Bài viết liên quan"
  empty: "Không có bài viết"
  type:
    news: "Tin tức"
    services: "Dịch vụ"
    handbook: "Cẩm nang"
    research_analytics: "Phân tích thị trường"
    buy_guide: "Mua bất động sản tại Việt Nam"
    investment: "Đầu tư"
    default: "Bài viết"
    all: "Tất cả bài viết"
  filtered_by_tag: "Bài viết theo thẻ"
  page: "Trang"
  image_not_available: "Hình ảnh không có sẵn"
  unknown_date: "Ngày không xác định"
  not_found: "Không tìm thấy bài viết"
  go_back: "Quay lại danh sách bài viết"
  property_guide:
    title: "Hướng dẫn quản lý bất động sản tại Việt Nam"
    property_types: "Các loại bất động sản"
    property_costs: "Chi phí bất động sản"
    legal_aspects: "Khía cạnh pháp lý"
    ownership_rules: "Quy định sở hữu"
    insurance_guidelines: "Hướng dẫn bảo hiểm"
    mortgages: "Thế chấp tại Việt Nam"
    taxation_policies: "Chính sách thuế"
  related_articles:
    title: "Bài viết liên quan"
    no_articles: "Không có bài viết liên quan"
    error: "Lỗi tải bài viết"
  slider:
    aria_label: "Bất động sản nổi bật"
    loading: "Đang tải bất động sản nổi bật"
form:
  title: "Điền vào biểu mẫu"
  subtitle: "Các chuyên gia của chúng tôi sẽ liên hệ với bạn sớm"
  name: "Tên"
  name_placeholder: "Nhập tên của bạn"
  name_required: "Tên là bắt buộc"
  phone: "Điện thoại"
  phone_placeholder: "+84 XXX XXX XXX"
  phone_required: "Điện thoại là bắt buộc"
  phone_invalid: "Định dạng điện thoại không hợp lệ"
  email: "Email"
  email_placeholder: "Nhập email của bạn"
  email_invalid: "Định dạng email không hợp lệ"
  comment: "Bình luận"
  comment_placeholder: "Nhập bình luận của bạn"
  message: "Tin nhắn"
  message_placeholder: "Nói cho chúng tôi biết mong muốn của bạn..."
  submit: "Gửi đi"
  submit_error: "Lỗi gửi biểu mẫu"
  success_title: "Cảm ơn bạn đã liên hệ!"
  success_message: "Chúng tôi đã nhận được yêu cầu và sẽ liên hệ với bạn trong thời gian sớm nhất"
  submit_another: "Gửi yêu cầu khác"
  privacy_note: "Bằng cách nhấp nút, bạn đồng ý với chính sách bảo mật và xử lý dữ liệu cá nhân"

sidebar_form:
  agent_name_placeholder: "Oleg Morozov"
  agent_role: "Đại lý VINPROP"
  headline: "Chúng tôi sẽ chọn 3 phương án tốt nhất cho ngân sách của bạn"
  description: "với dự báo lợi nhuận và thời gian hoàn vốn"
  submit: "Nhận lựa chọn cá nhân"

validation:
  required_name: "Tên là bắt buộc"
  required_phone: "Số điện thoại là bắt buộc"
  invalid_phone: "Vui lòng nhập số điện thoại hợp lệ"
  required_email: "Email là bắt buộc"
  invalid_email: "Vui lòng nhập email hợp lệ"

error:
  network: "Lỗi mạng: {message}"
  server: "Lỗi máy chủ: {message}"
  form_submit: "Không thể gửi biểu mẫu. Vui lòng thử lại sau."
  general: "Đã xảy ra lỗi"

residential_complex:
  all_title: "Bất động sản"
  reset_filters: "Đặt lại bộ lọc"
  no_complexes: "Không có khu phức hợp dân cư"
  more_details: "Chi tiết thêm"
  all_loaded: "Đã tải tất cả các dự án"

complex_features:
  invalid: "Không xác định"
  favorites: "Yêu thích"
  docs_checked: "Tài liệu đã kiểm tra"
  video_available: "Có video"
  handovered: "Đã bàn giao"
  pink_book_available: "Có sổ hồng"
  available_for_foreigners: "Có sẵn cho người nước ngoài"

filters:
  title: "Bộ lọc"
  project_rank: "Hạng dự án"
  amenities_title: "Tiện ích"
  features_title: "Tính năng"
  rank:
    invalid: "Không xác định"
    affordable: "Bình dân"
    mid_end: "Trung cấp"
    high_end: "Cao cấp"
    luxury: "Sang trọng"

complex_card:
  price_from: "từ {price}"
  price_on_request: "Giá theo yêu cầu"
  details: "Chi tiết"
  handover_date_not_specified: "Ngày bàn giao không được chỉ định"
  handover_completed: "Hoàn thành"
  handover_in_years: "Bàn giao trong {years} {label}"
  handover_in_months: "Bàn giao trong {months} {label}"
  handover_in_year: "Bàn giao vào năm {year}"
  handover_in_quarter: "Bàn giao quý {quarter} năm {year}"
  quarter_1: "1"
  quarter_2: "2"
  quarter_3: "3"
  quarter_4: "4"
  from: "từ"
  to: "đến"
  sqm: "m²"
  area: "Diện tích"
  price_range: "Khoảng giá"
  request_contacts: "Yêu cầu liên hệ"
  apartments_available: "{count} căn hộ có sẵn"
  sold_out: "ĐÃ BÁN HẾT"
  studio: "Studio"
  delivery_in: "Bàn giao vào"

complex_details:
  characteristics:
    due_date: "Thời hạn bàn giao"
    class: "Phân khúc"
    altitude: "Độ cao"
    room_type: "Loại phòng"
    transport: "Khả năng tiếp cận giao thông"
    info_not_available: "Thông tin không có sẵn"
  features:
    reputable_developer: "Nhà phát triển uy tín"
    installment_plan: "Kế hoạch trả góp"
    full_legal_ground: "Cơ sở pháp lý đầy đủ"
    high_appreciation_potential: "Tiềm năng tăng giá cao"
  class_type:
    high_end: "Cao cấp"
    mid_range: "Trung cấp"
    economy: "Bình dân"
    luxury: "Hạng sang"
    invalid: "Không xác định"
  room_type:
    apartment: "Căn hộ"
    penthouse: "Penthouse"
    duplex: "Duplex"
    studio: "Studio"
    invalid: "Không xác định"
  developer_label: "Nhà phát triển"
  handover_date_label: "Thời hạn bàn giao"
  project_class_label: "Phân khúc dự án"
  complex_by_developer: "Khu phức hợp dân cư của nhà phát triển {name}"
  infrastructure: "Cơ sở hạ tầng của khu phức hợp"
  construction_progress: "Tiến độ xây dựng"
  construction_progress_description: "Hình ảnh từ công trường xây dựng khu phức hợp dân cư"
  construction_progress_date: "Hình ảnh tính đến {date}"
  amenity_categories:
    establishment: "Cơ sở"
    for_children: "Cho trẻ em"
    sport: "Thể thao"
    entertainment: "Giải trí"
    outdoor: "Ngoài trời"
    common_area: "Khu vực chung"
  amenities:
    bar: "Quán bar"
    restaurant: "Nhà hàng"
    spa: "Spa"
    yoga: "Yoga"
    convenience_store: "Cửa hàng tiện lợi"
    shopping_mall: "Trung tâm mua sắm"
    school: "Trường học"
    kindergarten: "Trường mẫu giáo"
    college: "Trường đại học"
    swimming_pool: "Hồ bơi"
    kids_playground: "Sân chơi trẻ em"
    gym: "Phòng tập thể dục"
    community_room: "Phòng cộng đồng"
    jogging_path: "Đường chạy bộ"
    bbq: "BBQ"
    green_area: "Khu vực xanh"
    tennis_court: "Sân tennis"
    kids_pool: "Hồ bơi trẻ em"
    parking: "Bãi đậu xe"
    cafe: "Quán cà phê"
  documents:
    construction_permit: "Giấy phép xây dựng"
    land_use_right_certificate: "Giấy chứng nhận quyền sử dụng đất"
    bank_letter_of_guarantee: "Thư bảo lãnh ngân hàng"
    sale_permit: "Giấy phép bán hàng"
    sale_permit_for_foreigners: "Giấy phép bán hàng cho người nước ngoài"
  master_plan: "Quy hoạch tổng thể"
  about_project: "Về dự án"
  location: "Vị trí"
  finishing_options: "Các lựa chọn hoàn thiện"
  finishing_options_from: "Các lựa chọn hoàn thiện từ {name}"
  about_developer: "Về nhà phát triển"
  documents_checking: "Kiểm tra tài liệu"
  other_complexes: "Các dự án khác của nhà phát triển"
  open_map: "Mở bản đồ"
  more_about_finishing: "Thêm về các lựa chọn hoàn thiện"
  go_to_developer_page: "Đi đến trang nhà phát triển"
  finishing_description: "Có nhiều lựa chọn hoàn thiện cho căn hộ"
  finishing_note: "Hình ảnh chỉ mang tính tham khảo và có thể khác với hoàn thiện thực tế"
  developer_contacts: "Liên hệ nhà phát triển"
  image_not_available: "Hình ảnh không có sẵn"
  plan_not_available: "Bản vẽ không có sẵn"
  get_consultation: "Nhận tư vấn"
  price_range: "{min} - {max}"
  offers_available: "Có {count} ưu đãi"
  contact_us: "Liên hệ với chúng tôi"
  contact_description: "Điền vào biểu mẫu bên dưới và chúng tôi sẽ liên hệ với bạn trong thời gian ngắn"
  available_apartments_in: "Căn hộ có sẵn tại {name}"
  apartments_available: "Căn hộ có sẵn"
  special_offers: "Ưu đãi đặc biệt"
  check_price_availability: "Kiểm tra giá và tình trạng hiện tại với quản lý"
  bedrooms_count: "{count} phòng ngủ"
  bedrooms: "{count} phòng ngủ"
  studio: "Studio"
  rooms_unspecified: "Chưa xác định số phòng"
  units_available: "{count} có sẵn"
  buy_now: "Mua ngay"
  more_detailed: "Chi tiết hơn"
  object_type: "Loại đối tượng"
  available_units: "Có sẵn"
  valid_until: "Có hiệu lực đến"
  established: "Thành lập"
  total_projects: "Tổng số dự án"
  completed_projects: "Dự án đã hoàn thành"
  years_experience: "Năm kinh nghiệm"
  visit_website: "Truy cập trang web"
  contact_form_intro: "Quan tâm đến {name}? Để lại yêu cầu và quản lý của chúng tôi sẽ liên hệ với bạn"
  benefit_consultation: "Tư vấn miễn phí từ chuyên gia"
  benefit_price: "Giá và ưu đãi hiện tại"
  benefit_viewing: "Sắp xếp xem bất động sản"
  benefit_documents: "Hỗ trợ kiểm tra tài liệu"
  full_address: "Địa chỉ đầy đủ"
  district: "Quận"
  city: "Thành phố"
  loading_map: "Đang tải bản đồ..."
  map_error: "Lỗi tải bản đồ"
  map_placeholder: "Bản đồ vị trí"
  open_in_google_maps: "Mở trong Google Maps"
  nearby_places: "Gần đây"
  meters: "m"
  photo_date: "Hình ảnh vào {date}"
  total_photos: "Tổng số hình ảnh: {count}"
  last_update: "Cập nhật lần cuối: {date}"
  documents_verified: "Tài liệu đã xác minh"
  documents_description: "Tất cả tài liệu dự án đã được kiểm tra hợp pháp bởi chuyên gia của chúng tôi"
  document_verified: "Đã xác minh"
  document_pending: "Đang xử lý"
  documents_note: "Thông tin tài liệu được cập nhật thường xuyên. Liên hệ quản lý để biết thông tin hiện tại."
  other_complexes_by: "Dự án khác của {name}"
  view_details: "Xem chi tiết"
  no_other_complexes: "Chưa có dự án khác từ nhà phát triển này"
  starting_price: "Giá khởi điểm"

footer:
  contacts: "Liên hệ:"
  company_section: "Công ty"
  legal_section: "Pháp lý"
  about: "Về chúng tôi"
  about_vinprop_title: "Về VINPROP"
  about_snippet: "VINPROP là công ty proptech quốc tế chuyên về thị trường bất động sản Việt Nam. Chúng tôi kết hợp các giải pháp công nghệ, phân tích và tư vấn cho các nhà đầu tư nước ngoài và trong nước. Chúng tôi cung cấp dịch vụ mua căn hộ, biệt thự và bất động sản thương mại tại Thành phố Hồ Chí Minh, Hà Nội, Đà Nẵng và các thành phố khác ở Việt Nam."
  projects_section: "Dự án / mua bất động sản"
  residential_complexes: "Khu phức hợp dân cư"
  gated_communities: "Khu dân cư biệt lập"
  holiday_homes: "Bất động sản nghỉ dưỡng"
  commercial_real_estate: "Bất động sản thương mại"
  services_section: "Dịch vụ"
  advisory_services: "Dịch vụ tư vấn"
  legal_consultation: "Tư vấn pháp lý"
  property_management: "Quản lý bất động sản"
  fit_out: "Hoàn thiện nội thất"
  partners: "Dành cho đối tác"
  legal_disclaimer: "Tuyên bố pháp lý"
  terms_of_use: "Điều khoản sử dụng"
  careers: "Tuyển dụng"
  privacy_policy: "Chính sách bảo mật"
  cookie_policy: "Chính sách cookie"
  handbook_section: "Cẩm nang bất động sản"
  buying_guide: "Hướng dẫn mua"
  legal_guide: "Hướng dẫn pháp lý"
  pm_guide: "Hướng dẫn quản lý"
  cities_ranking: "Xếp hạng thành phố và khu vực"
  market_guide: "Hướng dẫn thị trường BĐS Việt Nam"
  developer_profiles: "Hồ sơ nhà phát triển"
  research_section: "Nghiên cứu và phân tích"
  news_blog: "Tin tức / blog"

time:
  year_single: "năm"
  year_few: "năm"
  year_many: "năm"
  month_single: "tháng"
  month_few: "tháng"
  month_many: "tháng"

cookie_consent:
  title: "Sử dụng Cookie"
  description: "Chúng tôi sử dụng cookie để cải thiện trải nghiệm của bạn trên trang web, phân tích lưu lượng truy cập và cá nhân hóa nội dung. Bạn có thể tùy chỉnh tùy chọn hoặc chấp nhận tất cả cookie."
  customize: "Tùy chỉnh"
  accept_all: "Chấp nhận tất cả"
  reject_all: "Chỉ cần thiết"
  save_preferences: "Lưu tùy chọn"
  necessary: "Cookie cần thiết"
  necessary_desc: "Những cookie này cung cấp chức năng cơ bản của trang web và không thể tắt."
  analytics: "Cookie phân tích"
  analytics_desc: "Giúp chúng tôi hiểu cách khách truy cập tương tác với trang web bằng cách thu thập thống kê ẩn danh."
  marketing: "Cookie tiếp thị"
  marketing_desc: "Được sử dụng để hiển thị quảng cáo có liên quan và theo dõi hiệu quả của các chiến dịch quảng cáo."
  preferences: "Cookie cá nhân hóa"
  preferences_desc: "Lưu tùy chọn của bạn (ngôn ngữ, chủ đề, v.v.) để cải thiện trải nghiệm người dùng."
city_autocomplete:
  placeholder: "Bắt đầu nhập tên thành phố"
  min_chars: "Nhập tối thiểu 2 ký tự"
  loading: "Đang tải…"
  not_found: "Không tìm thấy kết quả"
  load_error: "Không thể tải danh sách thành phố"
  retry: "Thử lại"
  clear: "Xóa"
  manual_entry: "Nhập thủ công: “{query}”"
  manual_suffix: "(nhập thủ công)"
  back_to_search: "Quay lại tìm kiếm theo danh mục"
